// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21euc","inner":"Footer_inner__1FRzt"};